import { withWindow } from '@shared/utils/withWindow';

/**
 * A same-site link with the page's `feature.*` overrides carried over, so a preview link
 * (`?feature.honeymoonBoard=on&feature.joy-web=pr…`) keeps the build and features it was opened with.
 * Parsed with the URL API, so a hash fragment stays a fragment; a relative link stays relative.
 */
export const withPreviewFlags = (href: string): string =>
  withWindow(window => {
    const flags = [...new URLSearchParams(window.location.search)].filter(([key]) => key.startsWith('feature.'));
    if (flags.length === 0) return href;
    const url = new URL(href, window.location.origin);
    flags.forEach(([key, value]) => url.searchParams.set(key, value));
    const isRelative = !/^[a-z][a-z\d+.-]*:/i.test(href) && !href.startsWith('//');
    return isRelative ? `${url.pathname}${url.search}${url.hash}` : url.toString();
  }, href);
